import React, { useRef, useState, useEffect } from "react";
import FeatureCard from "./components/FeatureCard";
import Navbar from "./components/Navbar";
import appDetails from "./data";
import Footer from "./components/Footer";

function AppIntroPage() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  // 恢复播放状态管理
  const [isPlaying, setIsPlaying] = useState(true); // 默认播放
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  // 用状态管理音量值，解决滑块显示问题
  // 在原有state后新增播放锁
  const [volume, setVolume] = useState(0);
  const [playLock, setPlayLock] = useState(false); // 新增：播放锁，防止连续调用

  // 播放/暂停切换逻辑
  // 完全替换原有togglePlay函数
  const togglePlay = async () => {
    if (!videoRef.current || playLock) return; // 加锁拦截重复操作
    setPlayLock(true); // 开启锁

    try {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        // 等待play异步执行完成，再更新状态
        await videoRef.current.play();
        setIsPlaying(true);
      }
    } catch (err) {
      console.warn("播放/暂停失败:", err);
    } finally {
      setPlayLock(false); // 无论成败，最终释放锁
    }
  };

  // 视频结束处理
  const handleEnded = () => {
    setIsPlaying(false);
    // 如需循环播放可取消注释
    // videoRef.current?.play();
    // setIsPlaying(true);
  };

  const handleError = () => {
    setIsLoading(false);
    setError(true);
  };

  // 空格键控制播放/暂停
  useEffect(() => {
    const handleKeyDown = (e) => {
      // 只在空格键且焦点不在输入框时触发
      if (
        e.code === "Space" &&
        !["INPUT", "TEXTAREA"].includes(document.activeElement.tagName)
      ) {
        e.preventDefault(); // 阻止页面滚动
        togglePlay();
      }
    };

    // 添加键盘事件监听
    window.addEventListener("keydown", handleKeyDown);

    // 清理函数
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isPlaying]);

  // 完全替换原有自动播放的useEffect
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const initPlay = async () => {
      video.muted = true;
      video.volume = 0;
      setVolume(0);
      try {
        // 初始化播放也加锁，避免和其他操作冲突
        setPlayLock(true);
        await video.play();
        setIsLoading(false);
        setIsPlaying(true);
      } catch (err) {
        console.warn("自动播放受限/视频源解析失败:", err);
        setIsLoading(false);
        // 视频源解析失败时，点击视频仅触发状态更新，不重复请求播放
        video.addEventListener(
          "click",
          () => {
            setIsPlaying((prev) => !prev);
          },
          { once: true },
        );
      } finally {
        setPlayLock(false);
      }
    };

    initPlay();

    // 组件卸载时，先暂停再置空状态
    return () => {
      if (video) {
        video.pause();
        setIsPlaying(false);
      }
    };
  }, []); // 移除volume依赖，彻底避免循环更新

  // 优化handleVolumeChange，增加异常捕获
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value) / 100;
    setVolume(newVolume);

    if (videoRef.current) {
      try {
        videoRef.current.muted = newVolume === 0;
        videoRef.current.volume = newVolume;
      } catch (err) {
        console.warn("音量调节失败:", err);
      }
    }
  };

  return (
    <div
      style={{
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: "#4b3621",
        backgroundColor: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <Navbar currentPath="/app" />

      {/* 介绍区 */}
      <section style={{ textAlign: "center", padding: "4rem 0 3rem" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "1rem",
              color: "#8b4513",
            }}
          >
            关于 {appDetails.name}
          </h2>
          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto 2rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            {appDetails.description}
          </p>
        </div>
      </section>

      {/* 视频区 - 修复版 */}
      <section
        style={{
          backgroundColor: "#f9f5f0",
          padding: "4rem 0",
          borderTop: "1px solid #f0e6db",
          borderBottom: "1px solid #f0e6db",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 1.5rem",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "1.5rem",
              color: "#8b4513",
            }}
          >
            {/* 你正如鸟儿，分享自己的思考，让万物复苏。 */}
          </h2>
          <p
            style={{
              textAlign: "center",
              maxWidth: "800px",
              margin: "0 auto 2.5rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            你将如同鸟儿，穿越森林、海洋，分享自己的感知，让世界承载一份你的力量，让万物复苏。
          </p>
          {/* <p
            style={{
              textAlign: "center",
              maxWidth: "800px",
              margin: "0 auto 2.5rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            视频自动静音播放，您可自行调节音量（点击视频可暂停/播放）。
          </p> */}

          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            {/* 视频容器 - 点击也可暂停/播放 */}
            <video
              ref={videoRef}
              src="https://ik.imagekit.io/albus/promotion_thoughtchains.mov"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "0.75rem",
                boxShadow: "0 4px 12px rgba(139, 69, 19, 0.08)",
                cursor: "pointer",
              }}
              autoPlay
              // 关键修改：从固定true改为由volume状态控制
              muted={volume === 0}
              playsInline
              loop={false}
              onEnded={handleEnded}
              onError={handleError}
              onClick={togglePlay}
              onLoadedMetadata={() => {
                if (videoRef.current) {
                  videoRef.current.volume = 0;
                  setVolume(0);
                  setIsLoading(false);
                }
              }}
              onCanPlayThrough={() => {
                if (videoRef.current && isPlaying) {
                  videoRef.current
                    .play()
                    .catch((err) => console.warn("自动播放兜底:", err));
                }
              }}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />

            {/* 音量控制 - 修复滑块显示问题 */}
            <div
              style={{
                position: "absolute",
                bottom: "2rem",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                backgroundColor: "rgba(0,0,0,0.7)",
                borderRadius: "0.5rem",
                padding: "0.5rem 1rem",
                zIndex: 10,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M3 9v6h4l5 5V4L7 9H3zm7-.172v4.343L13.172 9H11V7h4v2h-2v2h2v2H9v-4c0-1.105.895-2 2-2h4a2 2 0 0 1 2 2v4z" />
              </svg>
              {/* 修复后的音量滑块 */}
              <input
                type="range"
                min="0"
                max="100"
                value={volume * 100} // 使用状态值，确保UI同步
                onChange={handleVolumeChange}
                style={{
                  width: "100px",
                  cursor: "pointer",
                  // 增强跨浏览器样式兼容性
                  WebkitAppearance: "none",
                  appearance: "none",
                  height: "6px",
                  borderRadius: "3px",
                  background: "rgba(255,255,255,0.3)",
                  outline: "none",
                }}
                // 自定义滑块拇指样式（解决点位不显示问题）
                className="volume-slider"
              />
            </div>

            {/* 加载/错误提示 */}
            {isLoading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: "1.5rem",
                  textShadow: "0 0 10px black",
                }}
              >
                加载中...
              </div>
            )}
            {error && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "red",
                  fontSize: "1.2rem",
                  textShadow: "0 0 5px black",
                }}
              >
                视频加载失败，请刷新页面重试。
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 核心功能区：响应式网格，不出现横向滚动 */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem 0",
          borderTop: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "2rem",
              color: "#8b4513",
            }}
          >
            值得一提
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "1.5rem",
            }}
          >
            {appDetails.features.map((feature, index) => (
              <FeatureCard key={index} feature={feature} />
            ))}
          </div>
        </div>
      </section>

      {/* 截图区：一行三张，按比例缩小，有间距 */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem 0",
          borderTop: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "2rem",
              color: "#8b4513",
            }}
          >
            这个软件长什么样？
          </h2>
          <p
            style={{
              textAlign: "center",
              maxWidth: "800px",
              margin: "0 auto 2.5rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            使用蓝、绿色撞色设计。还有很多细节和功能值得去软件里探索～
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "1.5rem",
            }}
          >
            {appDetails.screenshots.map((src, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* 截图容器：加相对定位和过渡 */}
                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "0.75rem",
                    boxShadow: "0 4px 12px rgba(139, 69, 19, 0.08)",
                    marginBottom: "0.75rem",
                    transition: "box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedImage(src)}
                >
                  <img
                    src={src}
                    alt={`App Screenshot ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      aspectRatio: "9 / 19.5",
                      objectFit: "cover",
                      display: "block",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
                {/* 说明文字 */}
                <div style={{ textAlign: "center", maxWidth: "90%" }}>
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      color: "#8b4513",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {appDetails.screenshotCaptions?.[index] ||
                      `功能展示 ${index + 1}`}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#7a6650",
                      lineHeight: "1.5",
                      margin: 0,
                    }}
                  >
                    {appDetails.screenshotDescriptions?.[index] ||
                      "直观的操作界面，让您轻松上手"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 群聊二维码部分 */}
      <section
        style={{
          backgroundColor: "#f9f5f0",
          padding: "4rem 0",
          borderTop: "1px solid #f0e6db",
          borderBottom: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "1.5rem",
              color: "#8b4513",
            }}
          >
            加入群聊
          </h2>
          <p
            style={{
              textAlign: "center",
              maxWidth: "600px",
              margin: "0 auto 2.5rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            扫码加入QQ群聊，与开发者直接交流，倾听更多思考者的故事
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "220px",
                height: "220px",
                backgroundColor: "#ffffff",
                borderRadius: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 8px 20px rgba(139, 69, 19, 0.1)",
                marginBottom: "1.5rem",
                overflow: "hidden",
              }}
            >
              <img
                src={appDetails.qrcodes.QQgroup}
                alt="用户交流群二维码"
                style={{
                  width: "90%",
                  height: "90%",
                  objectFit: "contain",
                }}
              />
            </div>
            <p style={{ color: "#7a6650", fontSize: "1rem" }}>
              看看有没有更多和自己一样喜欢思考的人
            </p>
          </div>
        </div>
      </section>

      {/* 下载区 */}
      <section
        id="download"
        style={{
          backgroundColor: "#ffffff",
          color: "#4b3621",
          textAlign: "center",
          padding: "4rem 0",
        }}
      >
        <div
          style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "1rem",
              color: "#8b4513",
            }}
          >
            收获一篇篇“议论文”
          </h2>
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "2rem",
              opacity: 0.9,
              color: "#7a6650",
            }}
          >
            下载{appDetails.name}，体验一下结构化思考的乐趣。
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            <a
              href={appDetails.downloadLinks.ios}
              style={{
                padding: "0.875rem 1.75rem",
                fontSize: "1rem",
                fontWeight: "600",
                backgroundColor: "#c76b30",
                color: "#fff",
                border: "none",
                borderRadius: "0.5rem",
                textDecoration: "none",
                transition: "background-color 0.2s ease, transform 0.2s ease",
              }}
            >
              App Store
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      {/* 图片放大模态框 */}
      {selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
          onClick={() => setSelectedImage(null)}
        >
          {/* 关闭按钮 */}
          <button
            onClick={() => setSelectedImage(null)}
            style={{
              position: "absolute",
              top: "1.5rem",
              right: "1.5rem",
              width: "40px",
              height: "40px",
              backgroundColor: "rgba(255,255,255,0.2)",
              border: "none",
              borderRadius: "50%",
              color: "#fff",
              fontSize: "1.5rem",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.35)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)")
            }
          >
            ×
          </button>

          <img
            src={selectedImage}
            alt="放大截图"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "0.75rem",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* 截图悬停效果 */}
      <style>{`
        img[alt^="App Screenshot"]:hover {
          transform: scale(1.02);
          box-shadow: 0 8px 24px rgba(139, 69, 19, 0.12);
        }
        div[style*="display: flex"][style*="flexDirection: column"]:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 28px rgba(139, 69, 19, 0.12);
        }
        @media (max-width: 768px) {
          section > div > h2 {
            font-size: 1.875rem !important;
          }
          div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="gridTemplateColumns: repeat(auto-fit, minmax(240px, 1fr))"] {
            grid-template-columns: 1fr !important;
          }
          /* 截图区在小屏幕单列 */
          div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 480px) {
          section > div > h2 {
            font-size: 1.5rem !important;
          }
          p[style*="fontSize: 1.125rem"] {
            font-size: 1rem !important;
          }
        }
        /* 截图悬停放大效果 */
        div[style*="overflow: hidden"][style*="borderRadius: 0.75rem"]:hover {
          box-shadow: 0 8px 24px rgba(139, 69, 19, 0.15);
        }
        div[style*="overflow: hidden"][style*="borderRadius: 0.75rem"]:hover img {
          transform: scale(1.05);
        }

        /* 在现有 style 标签内添加这段样式 */
.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #8b4513;
  cursor: pointer;
  border: 2px solid white;
}
.volume-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #8b4513;
  cursor: pointer;
  border: 2px solid white;
  border: none;
}

      `}</style>
    </div>
  );
}

export default AppIntroPage;

// import React from "react";
// import FeatureCard from "./components/FeatureCard";
// import Navbar from "./components/Navbar";
// import appDetails from "./data";

// function AppIntroPage() {
//   return (
//     <div
//       style={{
//         fontFamily:
//           "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//         color: "#4b3621",
//         backgroundColor: "#ffffff",
//         minHeight: "100vh",
//       }}
//     >
//       <Navbar currentPath="/app" />

//       {/* 介绍区 */}
//       <section style={{ textAlign: "center", padding: "4rem 0 3rem" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               marginBottom: "1rem",
//               color: "#8b4513",
//             }}
//           >
//             关于 {appDetails.name}
//           </h2>
//           <p
//             style={{
//               maxWidth: "800px",
//               margin: "0 auto 2rem",
//               fontSize: "1.125rem",
//               color: "#7a6650",
//               lineHeight: "1.7",
//             }}
//           >
//             {appDetails.description}
//           </p>
//         </div>
//       </section>

//       {/* 核心功能区：一行 4 个特色卡片，白色背景 */}
//       <section
//         style={{
//           backgroundColor: "#ffffff",
//           padding: "3rem 0",
//           borderTop: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "2rem",
//               color: "#8b4513",
//             }}
//           >
//             核心功能
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(4, 1fr)",
//               gap: "1rem",
//             }}
//           >
//             {appDetails.features.map((feature, index) => (
//               <FeatureCard key={index} feature={feature} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 截图区：一行 3 个，白色背景 */}
//       <section
//         style={{
//           backgroundColor: "#ffffff",
//           padding: "3rem 0",
//           borderTop: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "1.5rem",
//               color: "#8b4513",
//             }}
//           >
//             应用截图
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(3, 1fr)",
//               gap: "0.75rem",
//             }}
//           >
//             {appDetails.screenshots.map((src, index) => (
//               <img
//                 key={index}
//                 src={src}
//                 alt={`App Screenshot ${index + 1}`}
//                 style={{
//                   width: "100%",
//                   borderRadius: "0.75rem",
//                   boxShadow: "0 4px 12px rgba(139, 69, 19, 0.08)",
//                   transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 新增的群聊二维码部分 */}
//       <section
//         style={{
//           backgroundColor: "#f9f5f0",
//           padding: "4rem 0",
//           borderTop: "1px solid #f0e6db",
//           borderBottom: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "1.5rem",
//               color: "#8b4513",
//             }}
//           >
//             加入群聊
//           </h2>
//           <p
//             style={{
//               textAlign: "center",
//               maxWidth: "600px",
//               margin: "0 auto 2.5rem",
//               fontSize: "1.125rem",
//               color: "#7a6650",
//               lineHeight: "1.7",
//             }}
//           >
//             扫码加入我们的群聊，与开发者直接交流，倾听更多思考者的故事
//           </p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               flexDirection: "column",
//             }}
//           >
//             <div
//               style={{
//                 width: "220px",
//                 height: "220px",
//                 backgroundColor: "#ffffff",
//                 borderRadius: "1rem",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 boxShadow: "0 8px 20px rgba(139, 69, 19, 0.1)",
//                 marginBottom: "1.5rem",
//                 overflow: "hidden",
//               }}
//             >
//               {/* 这里放置您的二维码图片 */}
//               <img
//                 src={appDetails.qrcodes.QQgroup}
//                 alt="用户交流群二维码"
//                 style={{
//                   width: "90%",
//                   height: "90%",
//                   objectFit: "contain",
//                 }}
//               />
//             </div>
//             <p style={{ color: "#7a6650", fontSize: "1rem" }}>
//               扫码加入，与万千用户一起探索
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* 下载区 */}
//       <section
//         id="download"
//         style={{
//           backgroundColor: "#ffffff",
//           color: "#4b3621",
//           textAlign: "center",
//           padding: "4rem 0",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               marginBottom: "1rem",
//               color: "#8b4513",
//             }}
//           >
//             准备好开始了吗？
//           </h2>
//           <p
//             style={{
//               fontSize: "1.25rem",
//               marginBottom: "2rem",
//               opacity: 0.9,
//               color: "#7a6650",
//             }}
//           >
//             立即下载 {appDetails.name}，开启全新体验。
//           </p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "1rem",
//               flexWrap: "wrap",
//             }}
//           >
//             <a
//               href={appDetails.downloadLinks.ios}
//               style={{
//                 padding: "0.875rem 1.75rem",
//                 fontSize: "1rem",
//                 fontWeight: "600",
//                 backgroundColor: "#c76b30",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: "0.5rem",
//                 textDecoration: "none",
//                 transition: "background-color 0.2s ease, transform 0.2s ease",
//               }}
//             >
//               App Store
//             </a>
//             <a
//               href={appDetails.downloadLinks.android}
//               style={{
//                 padding: "0.875rem 1.75rem",
//                 fontSize: "1rem",
//                 fontWeight: "600",
//                 backgroundColor: "transparent",
//                 color: "#c76b30",
//                 border: "2px solid #c76b30",
//                 borderRadius: "0.5rem",
//                 textDecoration: "none",
//                 transition: "background-color 0.2s ease, transform 0.2s ease",
//               }}
//             >
//               Google Play
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer
//         style={{
//           textAlign: "center",
//           padding: "2rem 0",
//           backgroundColor: "#f7f2eb",
//           color: "#7a6650",
//           fontSize: "0.95rem",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <p>
//             &copy; {new Date().getFullYear()} {appDetails.name}. All Rights
//             Reserved.
//           </p>
//         </div>
//       </footer>

//       {/* 截图悬停效果 */}
//       <style>{`
//         img[alt^="App Screenshot"]:hover {
//           transform: scale(1.05);
//           box-shadow: 0 8px 24px rgba(139, 69, 19, 0.12);
//         }
//       `}</style>
//     </div>
//   );
// }

// export default AppIntroPage;
